"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSermonEndpoint = exports.publishSermonEndpoint = exports.editSermonEndpoint = exports.addSermonEndpoint = exports.sermonTypesEndpoint = exports.sermonSpeakersEndpoint = exports.sermonsEndpoint = void 0;
var routes_1 = require("~shared/utils/routes");
exports.sermonsEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/sermons',
    method: 'post'
});
exports.sermonSpeakersEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/speakers',
    method: 'post'
});
exports.sermonTypesEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/sermonTypes',
    method: 'post'
});
exports.addSermonEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/addSermon',
    method: 'post'
});
exports.editSermonEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/editSermon',
    method: 'post'
});
exports.publishSermonEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/publishSermon',
    method: 'post'
});
exports.deleteSermonEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/deleteSermon',
    method: 'post'
});
//# sourceMappingURL=sermons.js.map